import MembershipDetails from "../MembershipDetails";

interface ArtistDetailsTabContentProps {
    artist: Artist;
    memberships: Membership[] | null;
    members: Membership[] | null;
}

const ArtistDetailsTabContent: React.FC<ArtistDetailsTabContentProps> = ({
    artist,
    memberships,
    members
}) => {
    const SUBUNIT = "subunit";
    const PRODUCTION = "production";

    // Helper function to filter memberships
    const filterMemberships = (memberships: Membership[] | null, filterFn: (m: Membership) => boolean) => {
        return memberships?.filter(filterFn) || [];
    };

    // Get all membership sections
    const membershipSections = [
        {
            data: filterMemberships(members, m => m.active === true && !m.group_type),
            type: "members"
        },
        {
            data: filterMemberships(members, m => m.active === false && !m.group_type),
            type: "past members"
        },
        {
            data: filterMemberships(memberships, m => m.active === true && m.group_type !== PRODUCTION),
            type: "groups"
        },
        {
            data: filterMemberships(memberships, m => m.active === false && (m.group_type === SUBUNIT || !m.group_type)),
            type: "past groups"
        },
        {
            data: filterMemberships(memberships, m => m.group_type === PRODUCTION),
            type: "production groups"
        },
        {
            data: filterMemberships(members, m => m.group_type === SUBUNIT),
            type: "subunits"
        }
    ];

    return (
        <div className="artist-details-tab">
            <div className="artist-details-content">
                {membershipSections.map((section, index) => (
                    section.data.length > 0 && (
                        <MembershipDetails
                            key={`${section.type}-${index}`}
                            memberships={section.data}
                            type={section.type}
                        />
                    )
                ))}
            </div>
        </div>
    );
};

export default ArtistDetailsTabContent; 